import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Header, Text, ColorBadge } from '@summer/ui-components';

import { Box, Flex } from 'components/box/Box';
import { getWindDownStatus } from 'utils/borrower';

import BorrowerAdminPanel from './BorrowerAdminPanel';

const DataSection = (props: any) => (
  <Section key="userHighInfo">
    {props.data.map((row: any, i: any) => {
      return (
        <GridRow key={i}>
          {row.map((item: any) => {
            return (
              <Grid key={item.label}>
                <Label weight="regular" size="medium">
                  {item.label}:
                </Label>
                <Text weight="bold" size="medium">
                  {item.value}
                </Text>
              </Grid>
            );
          })}
        </GridRow>
      );
    })}
  </Section>
);

const BorrowerHighInfo = ({ data, borrower }: any) => {
  const { profile } = borrower;
  const windDownStatus = getWindDownStatus({ borrower });

  return (
    <>
      <Container as="section">
        <HeaderFlex alignItems="center">
          <Header {...({} as any)}>
            {profile.firstName} {profile.lastName}
          </Header>
          {windDownStatus.statusLabel && (
            <WindDownBadge
              // @ts-expect-error badgeColorName is string | null, not a ColorBadge colour
              colorName={windDownStatus.badgeColorName}
              shortLabel="WD"
            >
              {windDownStatus.statusLabel}
            </WindDownBadge>
          )}
          <BorrowerAdminPanel borrower={borrower} />
        </HeaderFlex>
        {data.map((section: any) => (
          <DataSection
            key={section.title}
            title={section.title}
            data={section.data}
            colWidth={section.colWidth || '1fr'}
          />
        ))}
      </Container>
    </>
  );
};

const Container = styled(Box)`
  background-color: #ffffff;
  margin-left: -48px;
  margin-right: -48px;
  padding: 48px;
  margin-top: 32px;
`;

const HeaderFlex = styled(Flex)`
  gap: 12px;
`;

const Section = styled.div`
  margin-top: 20px;
  margin-bottom: 40px;
`;

const GridRow = styled.div`
  display: grid;
  grid-gap: 50px;
  grid-template-columns: 2fr 1fr 1fr;

  margin-bottom: 8px;
`;
const Grid = styled.div`
  display: flex;
  flex-direction: row;
  height: 26px;
`;
const Label = styled(Text)<any>`
  margin-right: 2px;
`;

const WindDownBadge = styled(ColorBadge)`
  margin-left: 16px;
  margin-right: 8px;
`;

BorrowerHighInfo.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.arrayOf(
        PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
          }).isRequired,
        ),
      ).isRequired,
      colWidth: PropTypes.string,
    }).isRequired,
  ),
};

export default BorrowerHighInfo;
